import { GridColDef } from '@mui/x-data-grid';
import { QueryResultRow } from '../types/query';

export const getColumns = (resultRow: QueryResultRow): GridColDef[] => {
  return Object.keys(resultRow).map((key) => ({
    field: key,
    headerName: key,
    width: 150,
    flex: 1,
  }));
};
